export default __webpack_public_path__ + "static/media/Just Kidding_final_2.dfeef7cd.jpg";